import { Schema as S } from "effect";
import { SchedulePayloadSchema } from "../schedule-payload.schema";

/**
 * Validated schedule payload after the SDK removes the vendor envelope.
 *
 * @since 1.1.8
 * @example
 * ```ts
 * S.decodeUnknownResult(ListSchedulesResponseSchema)([]);
 * ```
 */
export const ListSchedulesResponseSchema = S.Array(SchedulePayloadSchema);

/**
 * Vendor schedules including explicit closure evidence.
 *
 * @since 1.1.8
 * @example
 * ```ts
 * const schedules: ListSchedulesResponse = [];
 * ```
 */
export type ListSchedulesResponse = S.Schema.Type<typeof ListSchedulesResponseSchema>;
